export const initMissionVisionTabs = (): void => {
  // Renamed function
  const tabContainers =
    document.querySelectorAll<HTMLElement>(".tabbed-content");

  if (tabContainers.length === 0) {
    return;
  }

  tabContainers.forEach((container) => {
    const tabNav = container.querySelector('[role="tablist"]');
    const tabButtons =
      container.querySelectorAll<HTMLButtonElement>('[role="tab"]');
    const tabPanels =
      container.querySelectorAll<HTMLElement>('[role="tabpanel"]');

    if (!tabNav || tabButtons.length === 0 || tabPanels.length === 0) {
      console.warn(
        "[Tabs] A tabbed content component is missing required elements."
      );
      return;
    }

    const switchTab = (newTabButton: HTMLButtonElement) => {
      // Deactivate all other buttons and panels
      tabButtons.forEach((button) => {
        button.classList.remove("active");
        button.setAttribute("aria-selected", "false");
        button.setAttribute("tabindex", "-1");
      });
      tabPanels.forEach((panel) => {
        panel.classList.remove("show", "active");
      });

      // Activate the new button
      newTabButton.classList.add("active");
      newTabButton.setAttribute("aria-selected", "true");
      newTabButton.setAttribute("tabindex", "0");
      newTabButton.focus();

      // Activate the corresponding panel
      const targetPanelId = newTabButton.getAttribute("data-tab-target");
      if (targetPanelId) {
        const targetPanel = container.querySelector<HTMLElement>(targetPanelId);
        if (targetPanel) {
          // The `show` class triggers the fade-in effect
          targetPanel.classList.add("show");
          // The `active` class makes it visible
          targetPanel.classList.add("active");
        }
      }
    };

    tabButtons.forEach((button) => {
      // Set initial tabindex for accessibility
      if (!button.classList.contains("active")) {
        button.setAttribute("tabindex", "-1");
      }

      button.addEventListener("click", (e) => {
        e.preventDefault();
        switchTab(e.currentTarget as HTMLButtonElement);
      });
    });

    // Keyboard navigation
    tabNav.addEventListener("keydown", (e) => {
      const key = e.key;
      if (
        key !== "ArrowRight" &&
        key !== "ArrowLeft" &&
        key !== "Home" &&
        key !== "End"
      ) {
        return;
      }

      const activeTab = container.querySelector<HTMLButtonElement>(
        '[role="tab"][aria-selected="true"]'
      );
      if (!activeTab) return;

      let newIndex: number;
      const buttonArray = Array.from(tabButtons);
      const currentIndex = buttonArray.indexOf(activeTab);

      if (key === "ArrowRight") {
        newIndex = (currentIndex + 1) % buttonArray.length;
      } else if (key === "ArrowLeft") {
        newIndex = (currentIndex - 1 + buttonArray.length) % buttonArray.length;
      } else if (key === "Home") {
        newIndex = 0;
      } else {
        // End key
        newIndex = buttonArray.length - 1;
      }

      switchTab(buttonArray[newIndex]);
    });
  });

  console.log("[Partials] Mission/Vision Tabs initialized."); // Updated log message
};
